// Accordion.tsx
import React, { useState } from "react";
import * as S from "./accordion.styles";
import { ReactComponent as IconDownArrow } from "../../../styles/assets/svg/icon-arrow-down.svg";
import { ReactComponent as IconUpArrow } from "../../../styles/assets/svg/icon-arrow-up.svg";

export interface AccordionProps {
  title: string;
  children: React.ReactNode;
  data: string;
}

export const Accordion = ({ title, data, children }: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <S.AccordionContainer>
      <S.AccordionHeader isOpen={isOpen} onClick={toggleAccordion}>
        <S.TitleContainer>
          <S.AccordionTitle>{title}</S.AccordionTitle>
          <S.AccordionTitleData>{data}</S.AccordionTitleData>
        </S.TitleContainer>
        <S.AccordionIcon isOpen={isOpen}>
          <IconDownArrow width={12} height={12} />
        </S.AccordionIcon>
      </S.AccordionHeader>
      <S.AccordionContent className={!isOpen ? "close-content" : ""}>
        {children}
      </S.AccordionContent>
    </S.AccordionContainer>
  );
};
